import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { SalesArticleSummary } from '@api/models/sales-article-summary';
import { ClearSearchResults, QuickSearch, SearchProducts, SearchProductsStart } from './search.actions';
import { SalesArticlesService } from '@api/services/sales-articles.service';
import { SalesArticleSimpleSummary } from '@api/models/sales-article-simple-summary';

export class SearchStateModel {
  query: string;
  results: SalesArticleSummary[];
  quickSearchResults: SalesArticleSimpleSummary[];
  loading: boolean;
}

@State<SearchStateModel>({
  name: 'search',
  defaults: {
    query: null,
    results: null,
    loading: false,
    quickSearchResults: null
  }
})
@Injectable()
export class SearchState {
  constructor(private salesArticlesService: SalesArticlesService) {}

  @Selector()
  static selectSearchResults(state: SearchStateModel) {
    return state.results;
  }
  @Selector()
  static selectSearchQuery(state: SearchStateModel) {
    return state.query;
  }
  @Selector()
  static selectLoading(state: SearchStateModel) {
    return state.loading;
  }
  @Selector()
  static selectQuickSearch(state: SearchStateModel) {
    return state.quickSearchResults;
  }

  @Action(SearchProductsStart)
  private searchProductsStart({ patchState }: StateContext<SearchStateModel>) {
    return patchState({ loading: true });
  }

  @Action(SearchProducts, { cancelUncompleted: true })
  private searchProducts(ctx: StateContext<SearchStateModel>, action: SearchProducts) {
    return this.salesArticlesService
      .apiProductsquerySalesarticlesSearchGet({ searchTerm: action.searchString })
      .subscribe({
        next: (results) => ctx.patchState({ query: action.searchString, results, loading: false }),
        error: () => ctx.patchState({ loading: false })
      });
  }

  @Action(ClearSearchResults)
  private clearSearchResults(ctx: StateContext<SearchStateModel>) {
    return ctx.patchState({ results: null, loading: false });
  }

  @Action(QuickSearch)
  private quickSearch(ctx: StateContext<SearchStateModel>, action: QuickSearch) {
    return this.salesArticlesService
      .apiProductsquerySalesarticlesQuickSearchGet({ searchTerm: action.searchString })
      .subscribe((results) => ctx.patchState({ quickSearchResults: results }));
  }
}
